export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0018s_0000_Black-&-White-43.e4573f9e.png";